import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {displayDateFromDate, formatDropdownData, settingCartDesc, getFormattedMetalType} from '../../../../utils/formatting';
import {isLoggedIn} from '../../../../utils/auth';
import {getMetalTypeChildDropdownData, calcChildMetalMarkup, getMinPrice} from '../../../../utils/product';
import {getJsonFromUrl} from '../../../../utils/url';

import {limitedSizes, ringSizes, ringSizesWomen, eternitySizes } from '../../../../constants/ringsizes';

import * as cartActionCreators from '../../../../actions/cart';
import * as commonActionCreators from '../../../../actions/common';
import * as productActionCreators from '../../../../actions/product';
import * as userActionCreators from '../../../../actions/user';
let allActionCreators = Object.assign({}, cartActionCreators, commonActionCreators, productActionCreators, userActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class ProductSettingBanner extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		let ringLabel = [
			{
				display: 'Size',
				value: '',
			}
		];

		this.state = {
			addingToCart: false,
			nextStepsOpen: false,
			wgOpen: false,
			ygOpen: false,
			rgOpen: false,
			imageIndex: 0,

			ringSizeData: ringLabel.concat(ringSizesWomen),
			limitedSizeData: ringLabel.concat(limitedSizes),
			eternitySizeData: ringLabel.concat(eternitySizes),

			ringSize: this.props.product && this.props.product.attrSize ? this.props.product.attrSize : '',
			metalType: this.props.product && this.props.product.attrMetal ? this.props.product.attrMetal : '',
			validationMessage: '',

			wishlistExpanded: false,
			selectedWishlistId: null,
			wishlistValidation: null,
			wishlistRequestPending: false,

			metalPriceDiff: this.props.product && this.props.product.attrMetal ? calcChildMetalMarkup(this.props.productData, this.props.product.attrMetal) : 0,
		};
	}

	componentDidMount() {
		// Code to trick try me to show up
		// if(window.location.host.indexOf('staging') >= 0) {
			try {
				if(cls_InovaDiamonds_Iframe) {
					cls_InovaDiamonds_Iframe.clear_Data_715();
					cls_InovaDiamonds_Iframe.init_Session();
				}
			} catch (err) {
				console.error(err);
			}
		// }
	}

	getMetalTypeOptions() {
		if(!this.props.productData || !this.props.productData.price || !this.props.productData.attributes) {
			return [];
		}
		return getMetalTypeChildDropdownData(this.props.productData);
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	changeMetalType(evt) {
    this.setState({
      metalType: evt.target.value,
      validationMessage: '',
    }, () =>{

  		let priceDiff = calcChildMetalMarkup(this.props.productData, this.state.metalType);
  		console.log(priceDiff);

  		this.setState({ metalPriceDiff: priceDiff });
    });
  }

  changeRingSize(evt) {
    this.setState({
      ringSize: evt.target.value,
      validationMessage: '',
    });
  }

	toggleNextSteps() {
		this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
	}

	toggleWgOpen() {
		this.setState({ wgOpen: !this.state.wgOpen }, () => {
			if(this.state.wgOpen) {
				this.setState({ 
					ygOpen: false,
					rgOpen: false,
				});
			}
		});
	}

	toggleYgOpen() {
		this.setState({ ygOpen: !this.state.ygOpen }, () => {
			if(this.state.ygOpen) {
				this.setState({ 
					wgOpen: false,
					rgOpen: false,
				});
			}
		});	
	}

	toggleRgOpen() {
		this.setState({ rgOpen: !this.state.rgOpen }, () => {
			if(this.state.rgOpen) {
				this.setState({ 
					wgOpen: false,
					ygOpen: false,
				});
			}
		});
	}

	openIntercom() {
		acquireIO.max();
	}

	setImageIndex(idx) {
		this.setState({ imageIndex: idx });
	}

	getShippingDate() {

		let SETTING_LEAD_DAYS = 15;
		let today = new Date();

		today.setDate(today.getDate() + SETTING_LEAD_DAYS);
		return today;
	}

	getProductName() {
		if(!this.props.productData || !this.props.productData.name) {
			return '';
		} else {
			let pName = this.props.productData.name;
			return pName.replace(/Ã©/g, 'é');
		}
	}

	getProductDescription() {
		if(!this.props.productData || !this.props.productData.description) {
			return '';
		} else {
			let desc = this.props.productData.description;
			return desc.replace(/Ã©/g, 'é');
		}
	}

	getProductPrice() {
		if(!getMinPrice(this.props.productData)) {
			return '';
		} else {
			return (parseInt(getMinPrice(this.props.productData)) + parseInt(this.state.metalPriceDiff));
		}
	}

	getMetalBase() {
		return this.props.productData.attributes.karat ? this.props.productData.attributes.karat : 14;
	}

	getProductMedia() {

		// console.log(this.props.productData);
		// console.log(this.props.productData.image_count <= 0);
		// console.log(!this.props.productData || this.props.productData.image_count <= 0);


		if(!this.props.productData || this.props.productData.image_count <= 0) {
			return [];
		} else {
			let images = [];
			for(let i = 0; i < this.props.productData.image_count; i++) {
				images.push('https://dd2-temp-img.s3.amazonaws.com/' + this.props.productData.sku + '/' + i + '.jpg');
			}

			if(this.props.productData.video_count) {
				for(let j = 0; j < this.props.productData.video_count; j++) {
					images.push('https://dd2-temp-img.s3.amazonaws.com/' + this.props.productData.sku + '/' + j + '.mp4');
				}
			}
 
			return images;
		}
	}

	addToCart() {

		if(!this.state.metalType) {
			this.setState({validationMessage: 'Please select a metal type'});
			return;
		}

		if(!this.state.ringSize) {
			this.setState({validationMessage: 'Please select a ring size'});
			return;
		}

		this.setState({ addingToCart: true });

		// sku, metalType, ringSize, metalBase, metalMod
		this.props.cartAddMetalSize(this.props.productData.sku, this.state.metalType, this.state.ringSize, this.getMetalBase(), this.state.metalPriceDiff, getMinPrice(this.props.productData), settingCartDesc(this.props.productData, this.state.metalType, this.state.ringSize))
		.then((resp) => {
			this.externalNav('checkout/cart');
		})
		.catch((errResp) => {
			this.setState({ addingToCart: false });
		});
	}

	addDiamond() {
		this.props.productSelectSetting(this.props.productData, this.state.metalType, this.state.ringSize);
		this.internalNav('gallery/engagement-rings?view=results&tabtype=diamond');
	}

	backToResults() {
		let pageNum = this.props.product.currentPage ? this.props.product.currentPage : 1;
		let urlData = getJsonFromUrl();
	    if(urlData && urlData.q) {

	    	const pageVal = this.props.product.currentPage && this.props.product.currentPage > 1 ? `&p=${this.props.product.currentPage}` : '';

	      this.internalNav('diamonds-direct-search?q=' + urlData.q + pageVal);
	      return;
	    }

    	this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=setting');
	}

	addToWishlist() {
		if(isLoggedIn()) {
			this.toggleWishlist();
		} else {
			this.props.commonOpenLogin();
		}
	}

	toggleWishlist() {
		this.setState({ 
			wishlistExpanded: !this.state.wishlistExpanded,
			// wishlistRequestPending: false,
		}, () => {
			if(this.state.wishlistExpanded) {
				this.setState({ wishlistRequestPending: false });
			}
		});
	}

	changeWishlist(evt) {
		if(evt.target.value == 'create') {
			this.internalNav('account');
		} else {
			this.setState({ selectedWishlistId: evt.target.value });
		}
	}

	saveAddToWishlist() {
		if(!this.state.selectedWishlistId) {
			this.setState({wishlistValidation: 'Please select a wishlist'})
		}

		this.setState({ wishlistRequestPending: true });
		this.props.userWishlistAddItem(this.state.selectedWishlistId, this.props.productData.sku)
		.then((resp) => {

			this.props.commonAlert('Added to wishlist!', 'Continue', 'default');
			this.toggleWishlist();
			// this.setState({ wishlistRequestPending: false });

			this.props.userGetWishlists()
			.then((respData) => {
				this.props.userSaveWishlists(respData.wishlists);
			});
		});
	}

	getWishlistList() {
		let dropdownData = formatDropdownData(this.props.user.wishlists, 'name', 'id', 'Select Wishlist');
		let createElement = {
			display: 'Create New Wishlist',
			value: 'create'
		}
		return dropdownData.concat(createElement);
	}

	getRoyalTNotice() {
		
		if(!this.props.productData || !this.props.productData.sku) {
			return '';
		}

		const royalSkus = ['SMDPL06228','SMDPL06540','SMDPL06537','SMDPL06539','SMDPL13016','SMDPL13017', 'SMDPL13018', 'SMDPL10951'];

		return royalSkus.includes(this.props.productData.sku) ? 'Minimum 2 carat center stone required' : '';
	}

	hasEternitySize() {
		if(!this.props.productData || !this.props.productData.sku) {
			return '';
		}

		const sizeSkus = [
			'BLDXL09033',
			'BLDLG07535',
			'BLDMD16242',
			'BLDXL09325',
			'BLDXL09326',
			'BLDXL09353',
			'BLDXL09354',
			'BLDLG07493',
			'BLDLG10577',
			'BLDMD22544',
			'BLDMD22546',
			'BLDSM15215',
			'BLDSM15216',
			'BLDSM19811',
			'BLDXL09335',
			'BLDMD19310',
			'BLDMD20797',
			'BLDLG00689',
			'BLDXL05912',
			'BLDXL06711',
			'BLDLG00539',
			'BLDLG00870',
			'BLDLG00916',
			'BLDMD03842',
			'BLDXL05775',
			'BLDLG01719',
			'BLDMD02500',
			'BLDXL01568',
			'BLDXL02985',
			'BLDXL05597',
			'BLDMD19733',
			'BLDXL12439',
			'BLDSM16887',
			'BDSAP01562',
			'BDSAP03470',
			'BDSAP03473',
			'BDSAP03498',
			'BLDLG05316',
			'BLDLG09879',
			'BLDSM02317',
			'BLDXL11509',
			'BLDXL16381',
			'BLDMD17662',
			'BLDXL19649',
			'BLDXL19655',
			'BLDXL19663',
			'BLDXL19679',
			'BLDXL19683',
			'BLDXL19687',
			'BLDXL19689',
			'BLDXL19700',
			'BLDXL19696',
			'BLDXL19708',
			'BLDXL19714',
			'BLDXL19716',
			'BLDXL19719',
			'BLDXL19720',
			'BLDLG15370',
			'BLDMD31667',
			'BLDXL11675',
			'BDSAP03475',
			'BLDXL17019',
			'BDSAP03501',
			'BDSAP05496',
			'BDSAP03496',
			'BDSAP04925',
		];

		return sizeSkus.includes(this.props.productData.sku);
	}

	hasLimitedSize() {
		if(!this.props.productData || !this.props.productData.sku) {
			return '';
		}

		const sizeSkus = [
			'BLDXL19696',
			'BLDXL19700',
			'BLDXL19708',
			'BLDXL19714',
			'BLDXL19716',
			'BLDXL19719',
			'BLDXL19720',
			'BLDXL19649',
			'BLDXL19655',
			'BLDXL19679',
			'BLDXL19663',
			'BLDXL19683',
			'BLDXL19687',
			'BLDXL19689',
			'BLDMD16242', 
			'BLDXL09325', 
			'BLDLG07535', 
			'BLDXL09353', 
			'BLDXL09354', 
			'BLDXL09326', 
		];

		return sizeSkus.includes(this.props.productData.sku);
	}

	altSizeMessage() {
		if(!this.props.productData || !this.props.productData.sku) {
			return '';
		}

		const sizeSkus = [
			'BLDMD16242',
			'BLDXL09325',
			'BLDLG07535',
			'BLDXL09353',
			'BLDXL09354',
			'BLDXL09326',
		];
		return sizeSkus.includes(this.props.productData.sku);
	}

	skipMetalType() {
		if(!this.props.productData || !this.props.productData.sku) {
			return '';
		}

		const skipSkus = [
			'PRL6N00146',
		];
		return skipSkus.includes(this.props.productData.sku);
	}

	hasNoPrice(product) {

  	if(!this.props.productData || !this.props.productData.attributes) {
  		return false;
  	}

  	const noPriceSkus = [
  		'CUSTM00001', 
			'CUSTM00002', 
			'CUSTM00003', 
			'CUSTM00004',
			'CUSTM00005', 
			'CUSTM00006', 
			'CUSTM00007', 
			'CUSTM00008', 
			'CUSTM00009', 
			'CUSTM00010', 
			'CUSTM00011', 
			'CUSTM00012', 
			'CUSTM00013', 
			'CUSTM00014',
			'CUSTM00015',
			'CUSTM00016',
			'CUSTM00020', 
			'CUSTM00021', 
			'CUSTM00022', 
			'CUSTM00027', 
			'CUSTM00028', 
			'CUSTM00029',
			'CUSTM00030',
  	];

  	return noPriceSkus.includes(this.props.productData.sku);
  }

	getSizeNotice() {

		const hasLimited = this.hasLimitedSize();
		const altMessage = this.altSizeMessage();

		if(!hasLimited) {
			return '';
		}

		if(altMessage) {
			return 'Total carat weight and number of diamonds varies by finger size. If the size you need is not listed, please chat with a virtual sales associate.';
		}

		return 'Total carat weight and number of diamonds varies by finger size. The quality of the diamonds is H-I color and VS clarity. If the size you need is not listed, please chat with a virtual sales associate.';
	}

	getMainMedia() {
		if(this.isMediaVideo(this.getProductMedia()[this.state.imageIndex])) {
			return <video autoPlay playsInline muted="muted" loop>
			  <source src={this.getProductMedia()[this.state.imageIndex]} type='video/mp4' />
			</video>;
		} else {
			console.log(this.getProductMedia()[this.state.imageIndex]);
			return <img src={this.getProductMedia()[this.state.imageIndex]} />;
		}
	}

	getThumbMedia(srcStr) {

		if(!srcStr) { return null; }

		if(this.isMediaVideo(srcStr)) {
			return <span>
				<img src={srcStr.replace('.mp4', '.jpg')} />
				<div className='playWrapper'>
					<i className={'fas fa-play'}></i>
				</div>
			</span>;
		} else {
			return <img src={srcStr} />;
		}
	}

	isMediaVideo(srcStr) {
		return srcStr ? srcStr.includes('.mp4') : false;
	}

	getRingSizeList() {
		if(this.hasEternitySize()) {
			return this.state.eternitySizeData;
		}
		if(this.hasLimitedSize()) {
			return this.state.limitedSizeData;
		}
		return this.state.ringSizeData;
	}

	render() {
		return <div className='ProductSettingBanner'>
			<div className='imageSection'>
				<div className='primaryImageWrapper'>
					{this.getProductMedia().length > this.state.imageIndex ?
						<span>{this.getMainMedia()}</span> :
						null
					}
				</div>
				<div className='thumbnailsWrapper'>
					{this.getProductMedia().map((img, j) => {
						return <div className='thumbWrapper' onClick={() => this.setImageIndex(j)} key={j} >
							<span>{this.getThumbMedia(img)}</span>
						</div>;
					})}
				</div>
			</div>
			<div className='descriptionSection'>
				<div className='settingTitle'>{this.getProductName()}</div>
				<div className='settingDescription'>{this.getProductDescription()}</div>
				{this.getRoyalTNotice() ?
					<div className='settingRoyalTNotice'>{this.getRoyalTNotice()}</div> :
					null
				}
				{this.getSizeNotice() ?
					<div className='settingRoyalTNotice'>{this.getSizeNotice()}</div> :
					null
				}
				<div className='settingConfigWrapper'>
					{this.state.validationMessage ? 
						<div className='configError'>{this.state.validationMessage}</div> :
						null
					}
					{!this.skipMetalType() ?
						<div className='metalTypeOptions'>
							<RhinoSelect
			          options={this.getMetalTypeOptions()}
			          value={this.state.metalType}
			          changeMethod={::this.changeMetalType}
			          rootClass='productSelect' />
						</div> :
						null
					}
					<div className='ringSizeSelect'>
						<RhinoSelect
		          options={this.getRingSizeList()}
		          value={this.state.ringSize}
		          changeMethod={::this.changeRingSize}
		          rootClass='productSelect' />
					</div>
				</div>
				<div className='priceWrapper' style={{ display: this.hasNoPrice() ? 'none' : 'block' }}>
					<div className='priceSign'>$</div>
					<div className='priceValue'>{this.getProductPrice().toLocaleString()}</div>
				</div>
				{!this.hasNoPrice() ?
					<div className={'priceNotice settingPriceNotice'}>(setting&nbsp;&nbsp;only)</div> :
					null
				}
				{this.state.addingToCart ?
					<div className='nextStepsInCart'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
					<div className='nextStepsWrapper'>
						<div className='nextStepsElement' onClick={::this.toggleNextSteps}>
							<div className='nextStepsHead'>
								<div className='nextStepsLabel'>Next Steps</div>
								<div className='nextStepsIcon'>
									<img src='https://ddw2.diamondsdirect.com/img/productpage/down.svg' />
								</div>
							</div>
							<div className={this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody'}>
								<div className='nextStepsBodyWrapper'>
									<div className='nextStepsItem' onClick={() => this.addToCart()}>Add to Cart</div>
									<div className='nextStepsItem' onClick={() => this.addDiamond()}>Add to Ring</div>
									<div className='nextStepsItem' onClick={() => this.backToResults()}>Back to Results</div>
									<div className='nextStepsItem' onClick={() => this.internalNav('contact-us')}>Request an Appointment</div>
								</div>
							</div>
						</div>
					</div>
				}
				<div className='shippingInfoWrapper'>
					<div className='shippingDateLine' style={{display: 'none'}}>Estimated Shipping Date: {displayDateFromDate(this.getShippingDate())}</div>
					<div className='shippingContactLine' style={{display: 'none'}}>Need it sooner?&nbsp;<span className='clickableText' onClick={::this.openIntercom}>Speak to an Expert</span></div>
					<div className='shippingFreeLine'>Free shipping and free lifetime jewelry care with every purchase -&nbsp;<span className='clickableText' onClick={() => this.props.scrollMethod()}>Learn More</span></div>
				</div>
				<div className='actionsWrapper'>
					<div className='actionItem' style={{display: 'none'}}>
						<div className={'actionIcon hint'}>
							<img src='https://ddw2.diamondsdirect.com/img/productpage/hint.svg' />
						</div>
						<div className='actionLabel'>Drop a Hint</div>
					</div>
					<div className='actionItem' onClick={() => this.internalNav('contact-us')}>
						<div className='actionIcon'>
							<img src='https://ddw2.diamondsdirect.com/img/productpage/consult.svg' />
						</div>
						<div className='actionLabel'>Consult an Expert</div>
					</div>
					<div className='actionItem' onClick={::this.addToWishlist}>
						<div className='actionIcon'>
							<img src='https://ddw2.diamondsdirect.com/img/productpage/wishlist.svg' />
						</div>
						<div className='actionLabel'>Add to Wishlist</div>
					</div>
				</div>
				<div className={this.state.wishlistExpanded ? 'wishlistConfigs expanded' : 'wishlistConfigs'}>
					{this.props.user.wishlists !== null ?
						<div>
							{this.props.user.wishlists.length === 0 ?
								<div className='noWishlistPrompt'>
									<div className='nwText'>No wishlists created</div>
									<div className='nwButton' onClick={() => this.internalNav('account')}>Create</div>
								</div> :
								<div className='selectWishlistPrompt'>
									{this.state.wishlistValidation ? 
										<div className='wlPrompt'>{this.state.wishlistValidation}</div> :
										null
									}
									<div className='selectPrompt'>Add to which wishlist?</div>
									<div className='selectWrapper'>
										<RhinoSelect
											options={this.getWishlistList()}
											value={this.state.selectedWishlistId}
											changeMethod={::this.changeWishlist}
											rootClass='productSelect' />
									</div>
									<div className='selectButtonWrapper' style={{ display: this.state.wishlistRequestPending ? 'inline-block' : 'none' }}>
										<div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Wishlist</div>
									</div>
									<div className='selectButtonWrapper' onClick={::this.saveAddToWishlist}  style={{ display: this.state.wishlistRequestPending ? 'none' : 'inline-block' }}>
										<div>Add to Wishlist</div>
									</div>
								</div>
							}
						</div> :
						null
					}
				</div>
			</div>
		</div>;
	}
}
export default ProductSettingBanner;

function mapStateToProps(state) {
  return {
  	product: state.product,
  	user: state.user,
  };
}

export const ProductSettingBannerContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductSettingBanner);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductSettingBanner.jsx